export { default } from './Feed';
export { default as Sermon } from './Sermon';
export { default as SeriesSingle } from './Single';
export { default as SeriesTrailer } from './SeriesTrailer';



// WEBPACK FOOTER //
// ./src/series/index.js